import { Check } from '@nosinovacao/fe-icons';
import { Button, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type InviteSuccessProps } from '../-model/props';

export function InviteSuccessLight({ email, onManageAccess }: Readonly<InviteSuccessProps>) {
  const { t } = useI18n();
  return (
    <div className="flex size-full flex-col max-tablet:pb-8">
      <div className="flex flex-col gap-2">
        <Check width={48} height={48} className="text-nos-green" />
        <h2
          className="font-bold text-nos-neutral-1000 font-title-h2"
          data-tid="title-invite-success"
        >
          {t('Services.Users.InviteSuccess.Title')}
        </h2>
        <p className="text-nos-neutral-900 font-text-p1" data-tid="text-invite-success-subtitle">
          {t('Services.Users.InviteSuccess.Subtitle', { email })}
        </p>
      </div>
      <Button
        className="mt-auto w-full tablet:w-fit"
        skin="light"
        type="button"
        onClick={onManageAccess}
        data-tid="button-manage-access"
      >
        {t('Services.Users.InviteSuccess.ManageAccess')}
      </Button>
    </div>
  );
}
